import { render, staticRenderFns } from "./PostalFormStep.vue?vue&type=template&id=a9cfbe5a"
import script from "./PostalFormStep.vue?vue&type=script&lang=js"
export * from "./PostalFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports